'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-tab-bar',
    cnOpen = "".concat(CLASSNAME, "--open"),
    cnList = "".concat(CLASSNAME, "__list"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnButtonActive = "".concat(cnButton, "--active"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnMenu = "".concat(CLASSNAME, "__menu"),
    cnMenuOpen = "".concat(cnMenu, "--open"),
    cnMenuList = "".concat(cnMenu, "__list"),
    cnMenuItem = "".concat(cnMenu, "__item"),
    cnMenuItemTitle = "".concat(cnMenuItem, "__title"),
    cnMenuItemActive = "".concat(cnMenuItem, "--active"),
    cnMenuButton = "".concat(cnMenu, "__button"),
    cnMenuTitle = "".concat(cnMenu, "__title"),
    cnMenuIcon = "".concat(cnMenu, "__icon"),
    cnMenuContentWrapper = "".concat(cnMenu, "__content-wrapper"),
    cnMenuContent = "".concat(cnMenu, "__content");
/**
 * @class TabBar
 * A tab bar / bottom bar.
 * All items should open a context menu (overlay) which provides more functionality to the user.
 */

var TabBar = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TabBar, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TabBar);

  function TabBar() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, TabBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClose", function () {
      _this.setState({
        open: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(TabBar, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove(cnOpen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var open = this.state.open;
      var fn = open ? 'add' : 'remove';
      document.body.classList[fn](cnOpen);
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu(items, title, index) {
      this.setState(function (state) {
        return {
          items: items,
          open: state.items !== items || !state.open,
          title: title,
          index: index
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          items = _this$props.items,
          _onClick = _this$props.onClick;
      var _this$state = this.state,
          activeItems = _this$state.items,
          open = _this$state.open,
          activeTitle = _this$state.title,
          index = _this$state.index;

      if (!items.length) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, cnOpen, open))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnMenu, _rollupPluginBabelHelpers.defineProperty({}, cnMenuOpen, open)),
        onClick: this.onClose
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnMenuContentWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnMenuTitle
      }, /*#__PURE__*/React__default.createElement("div", null, activeTitle), /*#__PURE__*/React__default.createElement(Icon, {
        className: cnMenuIcon,
        id: "times-small",
        size: "xs"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnMenuContent,
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: cnMenuList
      }, Array.isArray(activeItems) ? activeItems.map(function (item, i) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: i,
          className: classNames(cnMenuItem, _rollupPluginBabelHelpers.defineProperty({}, cnMenuItemActive, item.active))
        }, /*#__PURE__*/React__default.createElement(Link, {
          link: item.link || '/',
          className: cnMenuButton,
          onClick: function onClick(e) {
            _this2.setState({
              open: false
            });

            _onClick(e, index, item);

            if (item.onClick) {
              item.onClick(e, index, item);
            }
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: cnMenuItemTitle
        }, item.title)));
      }) : activeItems)))), /*#__PURE__*/React__default.createElement("ul", {
        className: cnList
      }, items.filter(function (a) {
        return !a.mobileHidden;
      }).map(function (_ref) {
        var icon = _ref.icon,
            title = _ref.title,
            items = _ref.items,
            id = _ref.id;
        return /*#__PURE__*/React__default.createElement("li", {
          key: id,
          className: cnItem
        }, /*#__PURE__*/React__default.createElement("button", {
          className: classNames(cnButton, _rollupPluginBabelHelpers.defineProperty({}, cnButtonActive, open && activeItems === items)),
          onClick: function onClick() {
            _this2.toggleMenu(items, title, id);
          }
        }, /*#__PURE__*/React__default.createElement(Icon, {
          id: icon,
          className: cnIcon,
          size: "sm"
        }), /*#__PURE__*/React__default.createElement("div", {
          className: cnTitle
        }, title), /*#__PURE__*/React__default.createElement(MaterialDrop, null)));
      })));
    }
  }]);

  return TabBar;
}(React__default.Component);
TabBar.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Array of items */
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      link: PropTypes.string,
      id: PropTypes.string,
      active: PropTypes.bool
    }))])
  })).isRequired,

  /** Callback function */
  onClick: PropTypes.func
};
TabBar.defaultProps = {
  items: [],
  onClick: function onClick() {
    return void 0;
  }
};

module.exports = TabBar;
